<template>
  <div v-if="isVisible"><slot /></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    productName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      productNameFilter: "lists/getProductNameFilter",
    }),
    isVisible() {
      return this.productNameFilter
        ? this.productName.toLowerCase().includes(this.productNameFilter)
        : true;
    },
  },
};
</script>
